import { Alert, Spin, Empty, Modal } from "antd";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FileSyncOutlined } from "@ant-design/icons";
import { BulkUpdateModalConfig } from "./BulkUpdateModalConfig";

const BulkUpdateModal = ({
  open,
  onCancel,
  selectedRowRecords,
  filteredSelectedRowsCount,
  actionType
}) => {
  const dispatch = useDispatch();

  //
  const config = BulkUpdateModalConfig[actionType];
  if (!config) {
    throw new Error(`Invalid BulkUpdate actionType: ${actionType}`);
  }
  const title = config.title(selectedRowRecords);
  const FormComponent = config.FormComponent;
  const targets = useSelector(config.targetsSelector);
  const loading = useSelector(config.loadingSelector);

  //
  const renewalKeys = useMemo(() => {
    return Array.isArray(selectedRowRecords)
      ? selectedRowRecords
        .map((r) => r?.RenewalKey)
        .filter(Number.isInteger)
      : [];
  }, [selectedRowRecords]);

  //
  useEffect(() => {
    if (!open || renewalKeys.length === 0) return;

    if (config.clearStateAction) {
      dispatch(config.clearStateAction());
    }

    dispatch(config.loadTargetsAction(renewalKeys));
  }, [open, renewalKeys, dispatch]);

  return (
    <Modal
      title={
        <>
          <FileSyncOutlined /> {title}
        </>
      }
      width={500}
      onCancel={() => onCancel(false)}
      open={open}
      destroyOnClose
      footer={null}
    >
      {filteredSelectedRowsCount < selectedRowRecords.length && (
        <Alert
          type="warning"
          showIcon
          style={{
            padding: "4px",
            marginBottom: "0",
          }}
          description={
            <>
              Only <b>{filteredSelectedRowsCount}</b> of{" "}
              <b>{selectedRowRecords.length}</b> reminders are visible.
              <br />
              All {selectedRowRecords.length} will be updated.
            </>
          }
        />
      )}

      {loading && (
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Spin />
        </div>
      )}

      {!loading && (
        targets.length === 0 ? (
          <Empty
            description={config.emptyText}
            style={{ marginTop: 40 }}
          />
        ) : (
          <FormComponent
            renewalKeys={renewalKeys}
            onCancel={onCancel}
            targets={targets}
            targetsLoading={loading}
            {...(config.producerSlot
              ? { producerSlot: config.producerSlot }
              : {})}
          />
        )
      )}
    </Modal>
  );
};

export default BulkUpdateModal;
